/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-08-14 16:17:55
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:17:02
 */

import _ from "lodash";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { Category } from "../models/category.model";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { TransService } from "./trans.service";

@Injectable()
export class CategoryService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/categories`;

  private _categories: BehaviorSubject<Category[]> = new BehaviorSubject(null);

  constructor(private transService: TransService, private http: HttpClient) {}

  createCategory(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  getCategories() {
    return this.http.get(`${this.url}?lang=${this.transService.lang}`);
  }

  getCategory(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateCategory(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteCategory(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  fetchCategories() {
    this.getCategories().subscribe(res => {
      const categories = res["payload"];
      this.updatedCategories(categories);
    });
  }

  updatedCategories(values) {
    let categories = values;

    if (!categories) categories = this._categories.value;

    if (!categories) return;

    switch (this.transService.lang) {
      case "ja":
        _.each(categories, category => {
          category.nameTrans = category.name_ja || category.name;
        });
        break;
      case "ko":
        _.each(categories, category => {
          category.nameTrans = category.name_ko || category.name;
        });
        break;
      case "cn":
        _.each(categories, category => {
          category.nameTrans = category.name_cn || category.name;
        });
        break;
      default:
        _.each(categories, category => {
          category.nameTrans = category.name;
        });
        break;
    }

    const sortedValues = _.sortBy(categories, category => category.nameTrans);

    this._categories.next([...sortedValues]);
  }

  get categories$() {
    return this._categories.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/services/category.service.ts